'use es6';

import { SET_IS_DRAGGING } from 'simple-menus-core/actions/ActionTypes';
export function setIsDragging(isDragging) {
  return {
    type: SET_IS_DRAGGING,
    isDragging
  };
}